module.exports = __webpack_public_path__ + "assets/map-point.f872f2dc.svg";